import { preventInteraction } from "./features/preventInteraction";
import { ui } from "./utils/ui";

export default () => {
    const accordionItems: NodeListOf<HTMLElement> = document.querySelectorAll('.accordion__item')
    accordionItems.forEach(item => {
        const header: HTMLElement | null = item.querySelector('.accordion__item__header');
        const content: HTMLElement | null = item.querySelector('.accordion__item__content');
        const plusIcon: SVGElement | null = item.querySelector('#accordion__icon--plus');
        const minusIcon: SVGElement | null = item.querySelector('#accordion__icon--minus');
        if (header && content && plusIcon && minusIcon) {
            header.addEventListener('click', () => {
                const isOpen: boolean = item.classList.contains('open');
                if (isOpen) {
                    item.classList.remove('open');
                    plusIcon.style.display = 'block';
                    minusIcon.style.display = 'none';
                    content.style.maxHeight = '0';

                } else {
                    item.classList.add('open');
                    plusIcon.style.display = 'none';
                    minusIcon.style.display = 'block';
                    content.style.maxHeight = content.scrollHeight + 'px';
                }
            });
        }
    });

    preventInteraction(ui.accordionPictures);
    preventInteraction(ui.accordionMovies);
    preventInteraction(ui.accordionEnrichments);

}